import styled from 'styled-components';
import { InputTextProps } from './InputText';

export const Input = styled.input<InputTextProps>`
  outline: 0;
  height: 44px;
  width: 100%;
  transition: border 0.1s;
  border-radius: ${(p) => p.theme.radius.full};
  border: 1px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.grey[50])};
  color: ${(p) => p.theme.colors.general.text};
  font-size: ${(p) => p.theme.font.size.sm};
  box-shadow: ${(p) => p.theme.shadows.pya};
  padding: 0 12px;
  padding-left: ${(p) => (p.paddingLeft ? p.theme.spacing[p.paddingLeft] : '12px')};
  // &:hover {
  //   background-color: ${(p) => p.theme.colors.grey[10]};
  // }

  &:focus {
    background-color: ${(p) => p.theme.colors.general.white};
    outline: 2px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.general.link)};
    outline-offset: -1px;
  }
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
  &::placeholder {
    color: ${(p) => p.theme.colors.general.placeholder};
  }
`;
export const InputTextArea = styled.textarea<InputTextProps>`
  outline: 0;
  height: 44px;
  width: 100%;
  transition: border 0.1s;
  border-radius: ${(p) => p.theme.radius.lg};
  padding-left: ${(p) => p.theme.spacing.xs};
  border: 1px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.grey[50])};
  color: ${(p) => p.theme.colors.general.text};
  font-size: ${(p) => p.theme.font.size.sm};
  box-shadow: ${(p) => p.theme.shadows.pya};
  padding: ${(p) => p.theme.spacing.sm};
  // &:hover {
  //   background-color: ${(p) => p.theme.colors.grey[10]};
  // }

  &:focus {
    background-color: ${(p) => p.theme.colors.general.white};
    outline: 2px solid ${(p) => (p.error ? p.theme.colors.general.error : p.theme.colors.general.link)};
    outline-offset: -1px;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${(p) => p.theme.colors.general.black};
  font-size: ${(p) => p.theme.font.size.xs};
  font-weight: ${(p) => p.theme.font.weight.semibold};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
`;

export const Description = styled.p`
  color: ${(p) => (p.color ? p.theme.colors.general[p.color] : p.theme.colors.general.textSecondary)};
  margin-top: 0;
  margin-bottom: ${(p) => p.theme.spacing.xxs};
  font-size: ${(p) => p.theme.font.size.sm};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
`;

export const Error = styled.div`
  color: ${(p) => p.theme.colors.general.error};
  margin-top: 6px;
  margin-bottom: ${(p) => p.theme.spacing.xs};
  font-size: ${(p) => p.theme.font.size.xxs};
  font-weight: ${(p) => p.theme.font.weight.semibold};
`;
export const Disclaimer = styled.div`
  color: ${(p) => p.theme.colors.general.info};
  margin-bottom: ${(p) => p.theme.spacing.xs};
  font-size: ${(p) => p.theme.font.size.sm};
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
`;
